import {formValidation} from '../form/form.js';

$(function(){
	let formEls = $('[data-form-ajax]');
	let waits = {};

	formEls.on('submit', function(e){
		e.preventDefault();
		let thisEl = $(this);

		// wait
		if(waits[thisEl.attr('action')]) return false;
		waits[thisEl.attr('action')] = true;
		thisEl.addClass('wait');

		// prevent form submit
		e.preventDefault();

		// form data
		var formData = new FormData(this);

		// add images
		var imagesEls = thisEl.find('[data-upload-image]');
		for(var i = 0; i < imagesEls.length; i++) {
			// get name
			var imagesWrapperEl = $(imagesEls[i]).closest('[data-field]');
			var name = imagesWrapperEl.attr('data-field');

			// if add image index
			if(imagesEls[i].hasAttribute('data-image-index')) {
				var imageIndex = +$(imagesEls[i]).attr('data-image-index');
				var image = imagesFiles[imageIndex];

				if(image) formData.append(name + '[]', image);

				// add image to imagePositions
				formData.set(name + '[' + i + '][type]', 'image');
			}

			// add attachment id
			if(imagesEls[i].hasAttribute('data-attachment-id')) {
				var attachID = +$(imagesEls[i]).attr('data-attachment-id');

				// add attachment to imagePositions
				formData.set(name + '[' + i + '][type]', 'attach');
				formData.set(name + '[' + i + '][ID]', attachID);
			}
		}
		
		// delete images
		var deleteImageEls = thisEl.find('[data-delete-image][data-attachment-id]');
		for(var i = 0; i < deleteImageEls.length; i++) {
			var imagesWrapperEl = $(imagesEls[i]).closest('[data-field]');
			var name = imagesWrapperEl.attr('data-field');

			formData.append(name + '_delete[]', +$(deleteImageEls[i]).attr('data-attachment-id'));
		}

		// set action
		formData.set('action', thisEl.attr('action'));

		// set captcha
		var captchaEl = thisEl.find('textarea[name=g-recaptcha-response]');
		if(captchaEl.length > 0) formData.set('recaptcha', captchaEl.val());

		// send request to server
		$.ajax({
			url: ajaxurl,
			type: thisEl.attr('method') ? thisEl.attr('method') : 'post',
			dataType: 'json',
			processData: false,
			contentType: false,
			cache: false,
			data: formData,
			success: function(response){
				// stop wait
				waits[thisEl.attr('action')] = false;
				thisEl.removeClass('wait');

				// if no response
				if(!response) {
					alertify.error('Непредвиденная ошибка');
					return;
				}

				// validate form
				formValidation(response.errors, response.messages, thisEl);

				// redirect to link
				if(response.redirect_link) window.location.href = response.redirect_link;
			},
			error: function(error){
				console.log(error);
				alertify.error('Непредвиденная ошибка')
			}
		});

		// prevent form submit
		return false;
	});
});